export default "__VITE_ASSET__B7Da9QDS__"